import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";
import { useSiteContent } from "@/lib/useSiteContent";

export default function Insights() {
  const { articles } = useSiteContent();
  const posts = (articles || []).slice(0, 3);

  return (
    <section id="insights" className="bg-[#FFFFFF] py-24 lg:py-32" data-testid="insights-section">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8">
        <Reveal>
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <Eyebrow>From our tax desk</Eyebrow>
              <h2 className="mt-4 font-display text-4xl font-medium leading-tight tracking-tight text-[#102036] sm:text-5xl">
                Tax insights, in plain language.
              </h2>
            </div>
            <Link
              to="/insights"
              data-testid="insights-view-all-link"
              className="group inline-flex shrink-0 items-center gap-2 rounded-full border border-[#102036]/20 px-7 py-3.5 text-[12px] font-bold uppercase tracking-[0.14em] text-[#102036] transition-all duration-300 hover:-translate-y-0.5 hover:border-[#3682AE]"
            >
              View all articles
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-8 md:grid-cols-3">
          {posts.map((a, i) => (
            <Reveal key={a.slug} delay={0.08 * i}>
              <Link
                to={`/insights/${a.slug}`}
                data-testid={`insight-card-${a.slug}`}
                className="group flex h-full flex-col overflow-hidden rounded-lg border border-[#102036]/10 bg-white transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_45px_rgb(12,24,42,0.09)]"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={a.image}
                    alt={a.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
                    loading="lazy"
                  />
                  <span className="absolute left-4 top-4 rounded-full bg-[#102036]/85 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-[#FFFFFF] backdrop-blur">
                    {a.category}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <h3 className="font-display text-2xl font-semibold leading-snug text-[#102036]">{a.title}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-[#4A5568]">{a.excerpt}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.16em] text-[#3682AE]">
                    Read article
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
